import {
  searchResultCountState,
  searchResultPagesState,
} from "@/context/states";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import BandListPage from "./BandListPage";
import LoadMoreButton from "./LoadMoreButton";
import MusikSuchenResultsContainer from "./MusikSuchenResultsContainer";
import MusikSuchenResultsControlsContainer from "./MusikSuchenResultsControlsContainer";
import MusikSuchenResultsCount from "./MusikSuchenResultsCount";
import SwitchListGridButton from "./SwitchListGridButton";

export default function MusikSuchenResultBands({ searchConfig }) {
  const searchResultCount = useRecoilValue(searchResultCountState);
  const [searchResults, setSearchResults] = useRecoilState(
    searchResultPagesState,
  );
  const [pageIndex, setPageIndex] = useState(1);

  useEffect(() => {
    if (pageIndex > 1) {
      const pages = [];
      for (let i = 0; i < pageIndex; i++) {
        pages.push(
          <BandListPage searchConfig={searchConfig} page={i} key={i} />,
        );
      }
      setSearchResults({ ...searchResults, bands: pages });
    }
  }, [pageIndex]);

  return (
    <MusikSuchenResultsContainer>
      <MusikSuchenResultsCount results={searchResultCount.bands} />
      <MusikSuchenResultsControlsContainer>
        <SwitchListGridButton />
      </MusikSuchenResultsControlsContainer>
      <Grid item xs={12}>
        <Grid container sx={{ gap: "0.5rem" }}>
          {searchResults.bands.map((band, index) => (
            <Grid container spacing={1} key={index}>
              {band}
            </Grid>
          ))}
          {searchResultCount.bands % 24 === 0 &&
            searchResults.bands.length !== 0 && (
              <Grid item xs={12}>
                <LoadMoreButton
                  pageIndex={pageIndex}
                  setPageIndex={setPageIndex}
                  label="Bands"
                />
              </Grid>
            )}
        </Grid>
      </Grid>
    </MusikSuchenResultsContainer>
  );
}
